




































































import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { SfLoader, SfInput, SfButton } from '~/components/StorefrontUi';
import type { PropType } from '@nuxtjs/composition-api';
import {
  ForgotPasswordFormFields,
  FormName,
} from '~/modules/customer/components/LoginModal/forms/types';

export default defineComponent({
  components: {
    ValidationObserver,
    ValidationProvider,
    SfInput,
    SfButton,
    SfLoader,
  },
  props: {
    form: {
      type: Object as PropType<ForgotPasswordFormFields>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const formCopy = ref<ForgotPasswordFormFields>();
    watch(
      () => props.form,
      (newForm) => {
        formCopy.value = { ...newForm };
      },
      { immediate: true, deep: true },
    );

    const changeForm = (formToNavigateTo: FormName) => {
      emit('change-form', formToNavigateTo);
    };

    return { formCopy, changeForm };
  },
});
